let swiper;
let swiperContent;

function initializeTechnicalDetails() {
  if (typeof Swiper !== 'undefined') {
    swiper = new Swiper(".section-technical-details__swiper-images", {
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });

    swiperContent = new Swiper(".section-technical-details__info__mobile", {
      loop: false,
    });

    function removeAllTechnicalDetailActive() {
      const allTechnicalDetailButton = document.getElementsByClassName("technical_detail")
      for (let i = 0; i < allTechnicalDetailButton.length; i++) {
        allTechnicalDetailButton[i].classList.remove("technical_detail__active");
      }
    }

    swiper.on('slideChange', function (e) {
      removeAllTechnicalDetailActive()
      const allTechnicalDetailButton = document.getElementsByClassName("technical_detail");
      allTechnicalDetailButton[swiper.activeIndex].classList.toggle("technical_detail__active");
      swiperContent.slideTo(swiper.activeIndex);
      
      // Update pagination bullets
      const bullets = document.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) => {
        if (index === swiper.activeIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
        } else {
          bullet.classList.remove('swiper-pagination-bullet-active');
        }
      });
    });

    swiperContent.on('slideChange', function (e) {
      swiper.slideTo(swiperContent.activeIndex);
    });

    function selectSwiper(index) {
      swiper.slideTo(index);
    }

    function onSelectTechnicalDetail(element) {
      removeAllTechnicalDetailActive();
      element.classList.toggle("technical_detail__active");
      const index = parseInt(element.getAttribute('swipe-index')) - 1;
      selectSwiper(index);
      
      // Update pagination bullets
      const bullets = document.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, i) => {
        if (i === index) {
          bullet.classList.add('swiper-pagination-bullet-active');
        } else {
          bullet.classList.remove('swiper-pagination-bullet-active');
        }
      });
    }

    // Make functions globally available
    window.selectSwiper = selectSwiper;
    window.onSelectTechnicalDetail = onSelectTechnicalDetail;
  } else {
    // If Swiper is not loaded yet, try again in 100ms
    setTimeout(initializeTechnicalDetails, 100);
  }
}

// Wait for both DOM and Swiper to be loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is already loaded
  if (typeof Swiper !== 'undefined') {
    initializeTechnicalDetails();
  } else {
    // If Swiper is not loaded yet, wait for it
    const checkSwiper = setInterval(function() {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiper);
        initializeTechnicalDetails();
      }
    }, 100);
  }
});
